import { render, staticRenderFns } from "./LightboxNext.vue?vue&type=template&id=bb408a3e"
import script from "./LightboxNext.vue?vue&type=script&lang=js"
export * from "./LightboxNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports